import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion' // Import Motion
import Mimi from '../../assets/headshot.png'; // importing my imgae
import MyCV from '../../assets/Prince_Mwenyemali_E-CV.pdf'
import { IoNewspaperSharp } from "react-icons/io5";

const AboutHero = () => {
  // Animation settings for a smooth fade-up effect
    const fadeInVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
        opacity: 1, 
        y: 0,
        transition: { duration: 2, ease: "easeOut" }
    }
    };

    return (
        <motion.section 
            className='home'
            initial="hidden"
            animate="visible"
            variants={fadeInVariant}
        >
            <div className="hero-grid h">
                <motion.div className="container p-2" variants={fadeInVariant}>
                    <h1 className='h1-dark'>ABOUT ME — THE ONLINE CV</h1>
                    <h2 className='h2-primary'>Technical Skills. Creative Results</h2>
                    <div className="wrapper">
                        <div className="description">
                            <p className="text-dark">
                                I am Prince Mwenyemali, an adaptable professional currently based in Nairobi, Kenya. 
                                My professional identity is built on a foundation of technical trade mastery and 
                                digital innovation. I view a website’s code like a building’s wiring—it must be clean, 
                                efficient, and hidden behind a beautiful, functional interface.
                            </p>
                        </div>
                        <div className="btns">
                            <button className="primary btn">
                                {/* Updated 'to' prop to use the imported MyCV variable */}
                                <Link to={MyCV} target="_blank" rel="noopener noreferrer" title="Prince's resume">
                                    My Resume {' '} <IoNewspaperSharp className='setting' />
                                </Link>
                            </button>
                        </div>
                    </div>
                </motion.div>

                <motion.div 
                    className="container"
                    variants={fadeInVariant}
                    transition={{ delay: 0.2 }} // Slight delay for the image
                >
                    <div className="wrapper">
                        <img src={Mimi} alt="Prince Mwenyemali" className='hero-img' title="Prince's headshot"/>
                    </div>
                </motion.div>
            </div>
        </motion.section>
    )
}

export default AboutHero